import React, { useEffect, useState } from 'react';
import { BannerPolicys, BreadcrumbPolicys, PolicyContent } from "../common"
import { getPathLanguage } from '../../../utils/params';
import { useLocation, useParams } from 'react-router-dom';
import { getLanguage, getQueryString } from '../../../utils/params';
import { getPolicyCategories } from '../policy.api';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';

const PolicyComponent = () => {
  const language = getLanguage(useLocation());
  const pathLanguage = getPathLanguage(useLocation());
  const params = useParams();
  const urlPolicy =
    params.category !== 'terms-of-service' &&
    params.category !== 'privacy-policy' &&
    params.category !== 'cancellation-policy';
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [policyDetail, setPolicyDetail] = useState('');
  if (params.category && urlPolicy) {
    window.location.href = pathLanguage;
  }

  useEffect(() => {
    showLoader();
    getPolicyCategories(getQueryString({ language, id: getIdByCategory(params.category) })).then(res => {
      if (res) {
        setPolicyDetail(res[0])
      }
      hideLoader();
    })
    window.scrollTo({ top: 0, behavior: 'smooth' });
    //eslint-disable-next-line
  }, [language, params.category]);

  const getIdByCategory = category => {
    let id = '';
    switch (category) {
      case 'terms-of-service':
        id = 1;
        break;
      case 'privacy-policy':
        id = 2;
        break;
      case 'cancellation-policy':
        id = 3;
        break;
      default:
        break;
    }
    return id
  }

  return (
    <>
      <BreadcrumbPolicys breadCrum={policyDetail.title}/>
      <BannerPolicys content={policyDetail} />
      <div className="user-rating-review my-5">
        <div className="container">
          <div className="page-for-owners">
            <PolicyContent content={policyDetail} />
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};

export default PolicyComponent;
